import { render, staticRenderFns } from "./MSelectColorSidecover.vue?vue&type=template&id=00992984&"
import script from "./MSelectColorSidecover.vue?vue&type=script&lang=ts&"
export * from "./MSelectColorSidecover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports